/**
 * CategorySelector - Searchable single-select for a client's categories.
 * Thin wrapper over the generic Combobox; the parent owns fetching and state.
 */
import { Combobox } from '@/client/components/ui/combobox';
import type { ClientCategoryResponse } from '@shared/types';

interface CategorySelectorProps {
  /** Categories for the currently selected client */
  categories: ClientCategoryResponse[];
  /** Selected categoryID (as string), or undefined for all categories */
  value: string | undefined;
  /** Called with the new categoryID, or undefined for all categories */
  onChange: (value: string | undefined) => void;
  /** Whether the selector is disabled */
  disabled?: boolean;
  /** Additional class for the container */
  className?: string;
}

export function CategorySelector({
  categories,
  value,
  onChange,
  disabled = false,
  className,
}: CategorySelectorProps) {
  return (
    <Combobox
      items={categories}
      value={value}
      onChange={onChange}
      getKey={(c) => String(c.categoryID)}
      getLabel={(c) => c.displayName?.trim() || c.categoryName}
      placeholder="All categories"
      searchPlaceholder="Search categories..."
      emptyText="No categories found."
      disabled={disabled}
      clearable
      allOption={{ label: 'All categories' }}
      className={className}
    />
  );
}
